import type { VehicleSearchFilters } from '../../api/services/lupp/inventory/dto.inventory';

/**
 * Default page size for vehicle search pagination
 */
export const DEFAULT_PAGE_SIZE = 10;

/**
 * Available page size options for pagination
 */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/**
 * Minimum search string length for VIN/batch number search
 */
export const MIN_SEARCH_LENGTH = 3;

export const PACKAGE_FILTER_FIELD_MAPPING = {
  packageComfort: 'vehiclePackage',
  packageHandling: 'dynamicPackage',
  packageTechnology: 'techPackage',
  packageTowing: 'towingPackage',
} as const;

/**
 * Maps table filter state keys to API filter keys
 * Used to transform UI filter state to API request format
 */
export const FILTER_KEY_MAPPING: Record<string, keyof VehicleSearchFilters> = {
  ...PACKAGE_FILTER_FIELD_MAPPING,
  appearance: 'appearance',
  wheels: 'wheels',
  exteriorColor: 'exteriorColor',
  interiorColor: 'interiorColor',
  roof: 'roof',
  driveTrain: 'driveTrain',
  drivetrain: 'driveTrain',
  dreamDrive: 'dreamDrive',
  adas: 'dreamDrive',
  soundSystem: 'soundSystem',
  variant: 'variant',
  trim: 'variant',
  model: 'model',
  frontSeats: 'frontSeats',
  rearSeats: 'rearSeats',
  vehiclePackage: 'vehiclePackage',
  comfortPackage: 'vehiclePackage',
  dynamicPackage: 'dynamicPackage',
  dynamicHandlingPackage: 'dynamicPackage',
  techPackage: 'techPackage',
  technologyPackage: 'techPackage',
  towingPackage: 'towingPackage',
  edition: 'edition',
  year: 'modelYear',
  modelYear: 'modelYear',
  availability: 'availability',
};

/**
 * Maps table column keys to API field names for sorting
 * API expects simple field names like "batchNumber", "vin", etc.
 */
export const COLUMN_TO_API_FIELD_MAPPING: Record<string, string> = {
  vin: 'vin',
  batchNumber: 'batchNumber',
  model: 'model',
  trim: 'variant',
  year: 'modelYear',
  availability: 'availability',
  exteriorColor: 'exteriorColor',
  interiorColor: 'interiorColor',
};
